import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const ProductCard = ({ product, onOpen, index = 0 }) => {
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${((e.clientX - r.left) / r.width) * 100}%`);
    e.currentTarget.style.setProperty("--my", `${((e.clientY - r.top) / r.height) * 100}%`);
  };
  return (
    <motion.button
      type="button"
      data-testid={`product-card-${product.slug}`}
      onClick={() => onOpen(product)}
      initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-5% 0px" }}
      transition={{ duration: 0.7, delay: (index % 4) * 0.08, ease: [0.2, 0.8, 0.2, 1] }}
      className="group text-left w-full"
    >
      <div className="tile-frame aspect-[4/5] rounded-[1.25rem] border border-slate-200/80" onMouseMove={onMove}>
        <img src={product.image} alt={product.name} loading="lazy" />
        <div className="absolute left-3 top-3 z-[2] flex gap-2">
          <span className="rounded-full glass px-2.5 py-1 font-mono text-[0.58rem] uppercase tracking-widest text-[var(--navy)]">{product.size_label}</span>
        </div>
        <div className="absolute bottom-3 right-3 z-[2] grid h-10 w-10 place-items-center rounded-full bg-white text-[var(--navy)] opacity-0 translate-y-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
          <ArrowUpRight size={16} />
        </div>
      </div>
      <div className="mt-4 flex items-start justify-between gap-3 px-1">
        <div>
          <h3 className="font-display text-xl sm:text-2xl font-medium tracking-tight text-[var(--navy)]">{product.name}</h3>
          <p className="mt-0.5 text-xs text-[var(--muted)]">{product.surface_label} · {product.tone}</p>
        </div>
        <span className="font-mono text-[0.6rem] uppercase tracking-widest text-slate-400 pt-1.5">{product.sku}</span>
      </div>
    </motion.button>
  );
};
